<template>
  <aside class="sidebar" :class="{ collapsed: isCollapsed }">
      
      <div class="brand" v-if="!isCollapsed">
        <img src="@/assets/logo-ad4.png" alt="Logo">

      </div>
      <div class="brand brand-m" v-else>
        <img src="@/assets/logo-ad4-m.png" alt="Logo">

      </div>
      
      <nav class="navigation">
        <router-link to="/home" class="nav-link" active-class="active" :title="isCollapsed ? 'Dashboard' : ''">
          <app-icon icon="hugeicons:dashboard-square-02" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Dashboard</span>
        </router-link>
        <router-link to="/campaigns" class="nav-link" active-class="active" :title="isCollapsed ? 'Campaigns' : ''">
          <app-icon icon="hugeicons:c-programming" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Campaigns</span>
        </router-link>
        <router-link to="/streamers" class="nav-link" active-class="active" :title="isCollapsed ? 'Streamers' : ''">
          <app-icon icon="hugeicons:user-arrow-left-right" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Streamers</span>
        </router-link>
        <router-link to="/formats" class="nav-link" active-class="active" :title="isCollapsed ? 'Formats' : ''">
          <app-icon icon="hugeicons:bar-chart" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Formats</span>
        </router-link>
        <router-link to="/reports" class="nav-link" active-class="active" :title="isCollapsed ? 'Reports' : ''">
          <app-icon icon="hugeicons:repository" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Reports</span>
        </router-link>
        <router-link to="/assets" class="nav-link" active-class="active" :title="isCollapsed ? 'Assets' : ''">
          <app-icon icon="hugeicons:school-report-card" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Assets</span>
        </router-link>
        <div class="nav-divider"></div>
        <router-link to="/settings" class="nav-link" active-class="active" :title="isCollapsed ? 'Settings' : ''">
          <app-icon icon="hugeicons:setting-07" width="18" />
          <span class="nav-text" v-if="!isCollapsed">Settings</span>
        </router-link>
      </nav>
      <div class="sidebar-footer">
        <button class="spec-btn collapse-btn" @click="toggleCollapse" :title="isCollapsed ? 'Expand panel' : 'Collapse panel'">
          <app-icon icon="hugeicons:square-arrow-data-transfer-horizontal" width="18" />
        </button>

        <img v-if="!isCollapsed" src="@/assets/logo-gam3laba.png" alt="LiquidThread">
        <img v-if="isCollapsed" src="@/assets/logo-gam3laba-m.png" alt="LiquidThread">
        
      </div>      

     
    </aside>
</template>

<script>
import { useConfigStore } from "@/store/config.js";

export default {
  name: "NaviPanel",
  props: {
    
  },
  data() {
    return {
      configStore: useConfigStore()
    };
  },
  computed: {
    isCollapsed() {
      return this.configStore.isCollapsed;
    }
  },
  mounted() {
  },
  methods: {   
    toggleCollapse() {
      this.configStore.toggleNaviCollapse();
    }
  }
};
</script>

<style>
  /* SIDEBAR */
  .sidebar {
    width: var(--sidebar-width);
    background: white;
    border-right: 1px solid var(--border);
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    height: 100%;
    transition: width 0.3s ease;
  }

  .sidebar.collapsed {
    width: 70px;
  }

  .sidebar-header {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid var(--border);
  }

  .collapse-btn {
    position: absolute;
    right: 4px;
    top: -30px;
  }

  

  .sidebar-footer {
    margin-top: auto;
    padding: 24px;
    border-top: 1px solid var(--border);
    font-size: 12px;
    color: var(--text-muted);
    text-align: center;
    position: relative;
  }

  .sidebar-footer strong {
    color: var(--orange);
    font-weight: 600;
  }

  .sidebar-footer img {
    max-width: 100%;
    height: auto;
    width: 194px;
  }

  .sidebar-footer p {
    margin-top: 4px;
  }

  .brand img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .brand {
    padding: 16px 56px;
    margin: 0 auto;
  }

  .brand-m {
    padding: 12px;
    margin-bottom: 24px;
  }

  .navigation {
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .sidebar.collapsed .navigation {
    padding: 0 8px;
  }

  .nav-link {
    text-decoration: none;
    color: var(--text-muted);
    padding: 12px 16px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 15.2px;
    transition: 0.2s;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .sidebar.collapsed .nav-link {
    padding: 12px 8px;
    justify-content: center;
  }

  .nav-icon {
    font-size: 20px;
    flex-shrink: 0;
  }

  .nav-text {
    white-space: nowrap;
    overflow: hidden;
  }

  .nav-link:hover, .nav-link.active {
    background: #fff7ed;
    color: var(--orange);
  }

  .nav-divider {
    height: 1px;
    background: var(--border);
    margin: 16px 0;
  }
</style>
